import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { focusStyle } from '../styles/mixins';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
    '&:focus-visible': {
      ...focusStyle(theme),
    },
  },
}), { name: 'TransLink', index: StylesIndexInjections.UI_ATOMS });
